<template>
	<core-save-button
		v-bind="$attrs"
		:href="upgradeUrl"
		target="_blank"
		:saving="isLoading"
		:disabled="isLoading"
		:failed="failed"
		v-on="$listeners"
		@click.prevent="openComms"
	>
		<template #successText><slot name="successText">Upgrade Complete! (Reloading)</slot></template>
		<template #errorText><slot name="errorText">Upgrade incomplete!</slot></template>
		<slot>Upgrade Now &amp; Save 35%</slot>
	</core-save-button>
</template>
<script lang="js">
import { featureMap } from '@/components/utils';

export default {
	inheritAttrs: false,
	props: {
		utmMedium: {
			type: String,
			required: true,
		},
		features: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			failed: false,
		};
	},
	computed: {
		upgradeUrl() {
			// Get non-plugin features.
			const features = this.features.filter((f) => {
				const found = !featureMap.find((m) => m.slug === f);
				return !found || !found.plugin;
			});

			return this.$urls.upgrade({ utm_medium: this.utmMedium }, features);
		},
		isLoading() {
			return this.$store.getters.isLoading('upgrade');
		},
	},
	mounted() {
		this.$bus.$on('upgradeWindowClosed', this.setFailed);
	},
	beforeDestroy() {
		this.$bus.$off('upgradeWindowClosed', this.setFailed);
		clearTimeout(this.timeout);
	},
	methods: {
		openComms() {
			this.failed = false;
			if (this.timeout) {
				clearTimeout(this.timeout);
			}
			this.$bus.$emit('triggerUpgradeWindow', this.upgradeUrl);
		},
		setFailed() {
			this.failed = true;
			this.timeout = setTimeout(() => {
				this.failed = false;
			}, 2000);
		},
	},
};
</script>
